import React, { useState } from "react";
import BotListApiReport from "./BotListApiReport";
import ViewBotApiReport from "./ViewBotApiReport";

export default function ManageApiReport() {
    const [showBotReport, setShowBotReport] = useState(false);
    const [selectedBot, setSelectedBot] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [botType, setBotType] = React.useState("all");

    return (
        <div>
            {showBotReport ? (
                <ViewBotApiReport selectedBot={selectedBot} setShowBotReport={setShowBotReport} />
            ) : (
                <BotListApiReport
                    currentPage={currentPage}
                    pageSize={pageSize}
                    setCurrentPage={setCurrentPage}
                    setPageSize={setPageSize}
                    setShowBotReport={setShowBotReport}
                    setSelectedBot={setSelectedBot}
                    selectedBot={selectedBot}
                    botType={botType}
                    setBotType={setBotType}
                />
            )}
        </div>
    );
}
